import {
  gPayGateway,
  gPayGatewayMerchantId,
  gPayMerchantId,
  gPayMerchantName,
} from '../config'

export const googlePaymentRequestParams = {
  apiVersion: 2,
  apiVersionMinor: 0,
  allowedPaymentMethods: [
    {
      type: 'CARD',
      parameters: {
        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
        allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'],
      },
      tokenizationSpecification: {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          gateway: gPayGateway,
          gatewayMerchantId: gPayGatewayMerchantId,
        },
      },
    },
  ],
  merchantInfo: {
    merchantId: gPayMerchantId,
    merchantName: gPayMerchantName,
  },
  transactionInfo: {
    totalPriceStatus: 'FINAL',
    // totalPriceLabel: 'Total',
    totalPrice: '0', // assigned in the hook
    currencyCode: 'UAH',
    countryCode: 'UA',
  },
}
